import React, { useEffect, useState } from 'react';
import { Container, ContainerLevel, ContainerModal } from './styles';
import { avatarDataType, basicsCharType, campainType, classeDataType, elementDataType, habilityCharUniqueDataType, habilityDataType, habilityTranscendedDataType, itemDataType, originDataType, skillType, subclassDataType, unlockType } from '../../../../types';
import { skillFiltr, skillTy } from '../..';
import logo from '../../../../imgs/profile-user-icon-2048x2048-m41rxkoe.png';
import Modal from '../../../../commom/Modal';
import { db } from '../../../../firebase/firebase';
import { arrayUnion, doc, updateDoc } from 'firebase/firestore';
import { ColorRing, Vortex } from 'react-loader-spinner';
import { levelUp, uploadImage } from '../../../../utils';
import EditInfo from './ModalEditInfo';
import { Avatar, Divider } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';

type prop = {
    charcater?: avatarDataType;
    campain?: campainType;
    skills: skillFiltr;
    onClose: () => void;
    isToCloseSheet: boolean;
    skillsAll: skillTy[];
    habilities: habilityDataType[];
    habilityTranscended: habilityTranscendedDataType[];
    subclasses: subclassDataType[];
    charSubclass?: subclassDataType;
    classChar?: classeDataType;
    elements: elementDataType[];
    toast: any;
    isAdmin?: boolean;
    originChar?: originDataType;
    habilityUnique?: habilityCharUniqueDataType[];
    itemsCharInventory?: itemDataType[];
}

const SheetDetails = ({ 
        charcater, 
        isAdmin, 
        campain, 
        skills, 
        onClose, 
        isToCloseSheet, 
        skillsAll, 
        habilities, 
        habilityTranscended, 
        subclasses, 
        charSubclass, 
        classChar, 
        elements, 
        toast, 
        originChar, 
        habilityUnique, 
        itemsCharInventory 
    }: prop) => {

    const [showHabilityModal, setShowHabilityModal] = useState<boolean>(false);
    const [showHabilityTranscendedModal, setShowHabilityTranscendedModal] = useState<boolean>(false);
    const [showSubclassModal, setShowSubclassModal] = useState<boolean>(false);
    const [showPerksModal, setShowPerksModal] = useState<boolean>(false);
    const [loadingAtt, setLoadingAtt] = useState<boolean>(false);
    const [editInfo, setEditInfo] = useState<boolean>(false);

    const [habilityToAdd, setHabilityToAdd] = useState<habilityDataType>();
    const [habilityTranscendedToAdd, setHabilityTranscendedToAdd] = useState<habilityTranscendedDataType>();
    const [subclassToAdd, setSubclassToAdd] = useState<subclassDataType>();

    
    const [habilitiesChar, setHabilitiesChar] = useState<habilityDataType[]>();
    const [habilitiesToAdd, setHabilitiesToAdd] = useState<habilityDataType[]>();
    const [habilityTranscendedChar, setHabilityTranscendedChar] = useState<habilityTranscendedDataType[]>();
    const [habilityTranscendedToAddList, setHabilityTranscendedToAddList] = useState<habilityTranscendedDataType[]>();

    const [calcDefense, setCalcDefense] = useState<number>(0);

    const [perksToUpgrade, setPerksToUpgrade] = useState<skillTy[]>([]);

    const [loading, setloading] = useState<boolean>(false);

    const [levelUpInfo, setLevelUpInfo] = useState<{
        beforeBasic: basicsCharType,
        unlock: unlockType;
        basics: basicsCharType;
        messages: {
            title: string;
            description: string;
        }[];
        state: boolean;
    }>();

    const handleCloseModalLevelUp = () => {
        setLevelUpInfo(undefined);
    }

    const handleClodeEdit = () => {
        setEditInfo(false);
    }

    useEffect(() => {
        if(skillsAll && skills.trained?.length > 0) {
            skillsAll?.forEach((i) => {
                const findSkill = skills?.trained?.find((j) => j.id === i.id);

                if(findSkill) {
                    i.expertise = findSkill?.expertise;
                }
            })
        }
    }, [skillsAll, skills]);

    const investigateSkillRequirement = (hability: habilityDataType): boolean => {
        if(!hability.data.require) return false;
        if (!hability.data.require.some((i) => i.toUpperCase().includes("TREINADO"))) return true;

        const isOr = hability.data.require?.some((j) => j.toUpperCase().includes(" OU "));

        const isAllValid = skillsAll?.filter((i) => {
            const str = i.name.toUpperCase();
            return hability.data.require?.some((j) => j.toUpperCase().includes(str));
        });

        if(isOr) {
            return isAllValid.some((i) => skills.trained?.some((j) => j.name === i.name));
        } else {
            return isAllValid.every((i) => skills.trained?.some((j) => j.name === i.name));
        }
    }

    const investigateRequirementAtribute = (hability: habilityDataType): boolean => {

        if(!hability.data.require) return true;

        const hasAtribute = hability?.data?.require?.some((i) => {
            const str = i.toUpperCase();

            if (str.includes('AGI') || str.includes('INT') || str.includes('VIG') || str.includes('PRE') || str.includes('FOR')) {
                return true;
            }

            return false;
        });

        if (!hasAtribute) return true;

        type AttributeKey = 'AGI' | 'INT' | 'VIG' | 'PRE' | 'FOR';

        for (const req of hability.data.require) {
            const match = req.match(/(AGI|INT|VIG|PRE|FOR)\s*(\d+)/i);
            if (match) {
                const attr = match[1].toUpperCase() as AttributeKey;
                const value = parseInt(match[2], 10);
                const atribute = charcater?.data[attr];
                if ((atribute ?? 0) < value) {
                    return false;
                }
            }
        }

        return true;
    }
    useEffect(() => {
        if (charcater && habilities) {
            const habilitiesFind = habilities?.filter((i) => charcater?.data?.hability?.some((j) => j === i?.id));
            const sorted = habilitiesFind?.sort((a, b) => a?.data?.name?.localeCompare(b?.data?.name));
            setHabilitiesChar(sorted);

            const habilitiesToAddFind = isAdmin ? habilities : habilities?.filter((i) => !charcater?.data?.hability?.includes(i?.id));
            const sortedToAdd = habilitiesToAddFind?.sort((a, b) => a?.data?.name?.localeCompare(b?.data?.name));

            setHabilitiesToAdd(sortedToAdd);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [charcater, habilities]);

    useEffect(() => {
        if (charcater && habilityTranscended) {
            const habilityTranscendedFind = habilityTranscended?.filter((i) => charcater?.data?.habilityTranscended?.some((j) => j === i?.id));
            const sortedTranscended = habilityTranscendedFind?.sort((a, b) => a?.data?.name?.localeCompare(b?.data?.name));
            setHabilityTranscendedChar(sortedTranscended);

            const habilityTranscendedToAddFind = habilityTranscended?.filter((i) => !charcater?.data?.habilityTranscended?.includes(i?.id));
            // Ordenar primeiro por elemento, depois por nome
            const sortedTranscendedToAdd = habilityTranscendedToAddFind?.sort((a, b) => {
                // Primeiro compara por elemento (se tiver)
                const elementA = a?.data?.element?.name || "";
                const elementB = b?.data?.element?.name || "";
                
                if (elementA !== elementB) {
                    return elementA.localeCompare(elementB);
                }
                
                // Se os elementos forem iguais, compara por nome
                return a?.data?.name?.localeCompare(b?.data?.name) || 0;
            });

            setHabilityTranscendedToAddList(sortedTranscendedToAdd);
        }
    }, [charcater, habilityTranscended]);

    const handleCloseHabilityModal = () => {
        setShowHabilityModal(false);
        setShowSubclassModal(false);
        setShowPerksModal(false);
    }

    const handleCloseHabilityTranscendedModal = () => {
        setShowHabilityTranscendedModal(false);
    }

    const addHability = async () => {
        if (habilityToAdd) {
            handleCloseHabilityModal();
            const userDocRef = doc(db, "character", charcater?.id ?? '');
            await updateDoc(userDocRef, {
                hability: arrayUnion(habilityToAdd.id),
                unlock: {
                    ...charcater?.data.unlock,
                    habilityPoints: (charcater?.data?.unlock?.habilityPoints ?? 0) - 1
                }
            }).then(() => {
                toast.success("Habilidade adicionada!");
                setHabilityToAdd(undefined);
            });
        }
        
    }

    const addHabilityTranscended = async () => {
        if (habilityTranscendedToAdd) {
            handleCloseHabilityTranscendedModal();
            const userDocRef = doc(db, "character", charcater?.id ?? '');

            await updateDoc(userDocRef, {
                habilityTranscended: arrayUnion(habilityTranscendedToAdd.id),
                basics: {
                    ...charcater?.data.basics,
                    sanity: {
                        max: charcater?.data.basics.sanity.max ? charcater?.data.basics.sanity.max - (classChar?.data.sanity.perLevel ?? 0) : charcater?.data.basics.sanity.max,
                        actual: charcater?.data.basics.sanity.actual ? charcater?.data.basics.sanity.actual - (classChar?.data.sanity.perLevel ?? 0) : charcater?.data.basics.sanity.actual,
                    }
                },
                unlock: {
                    ...charcater?.data.unlock,
                    habilityPoints: (charcater?.data?.unlock?.habilityPoints ?? 0) - 1
                }
            }).then(() => {
                toast.success("Habilidade transcendida adicionada!");
                setHabilityTranscendedToAdd(undefined);
            });
        }
        
    }

    const addSubclass  = async () => {
        if (subclassToAdd) {
            handleCloseHabilityModal();
            const userDocRef = doc(db, "character", charcater?.id ?? '');

            await updateDoc(userDocRef, {
                subclass: {
                    id: subclassToAdd.id,
                    title: subclassToAdd.data.name,
                },
            }).then(() => {
                toast.success("Subclasse selecionada!");
                setSubclassToAdd(undefined);
            });
        }
        
    }

    const updatePerks  = async () => {
        if (!!perksToUpgrade.length) {
            handleCloseHabilityModal();

            const skillsChar = charcater?.data.skill;
            const newSkillsChar = [] as skillType[];

            skillsAll?.forEach((i) => {
                const isToUpgrade = perksToUpgrade?.find(j => j?.id === i?.id);

                const alreadyIn = skillsChar?.find(j => j?.perk === i?.id);
                
                if (!!isToUpgrade){
                    newSkillsChar.push({
                        perk: i?.id,
                        expertise: isToUpgrade?.expertise
                    } as skillType);

                    return;
                } 

                if (!!alreadyIn) {
                    newSkillsChar.push({
                        perk: i?.id,
                        expertise: alreadyIn?.expertise
                    } as skillType);

                    return;
                }
            })

            const userDocRef = doc(db, "character", charcater?.id ?? '');

            await updateDoc(userDocRef, {
                skill: newSkillsChar,
                unlock: {
                    attributePoints: charcater?.data?.unlock?.attributePoints,
                    habilityPoints: charcater?.data?.unlock?.habilityPoints,
                    maxPerkLevel: charcater?.data?.unlock?.maxPerkLevel,
                    perkPoints: (charcater?.data?.unlock?.perkPoints ?? 0) - perksToUpgrade.length,
                    levelPoint: charcater?.data?.unlock?.levelPoint ?? 0,
                }
            }).then(() => {
                toast.success("Perícias atualizadas!");
                setSubclassToAdd(undefined);
            });

            setPerksToUpgrade([]);
        }
    }

    const verifyPerkToImprove = (perk: skillTy) => {
        if(charcater && perk) {
            if(charcater?.data?.unlock?.perkPoints <= 0) return false;

            if ((perk?.expertise ?? 0) >= charcater?.data?.unlock?.maxPerkLevel) {
                return false;
            }

            if (perksToUpgrade?.length >= charcater?.data?.unlock?.perkPoints) {
                return false;
            }
        }
        
        return true;
    }

    const upAttribute = async (att: 'INT' | 'AGI' | 'FOR' | 'PRE' | 'VIG') => {
        setLoadingAtt(true);
        const userDocRef = doc(db, "character", charcater?.id ?? '');

        const dataToUp = {
            [att]: (charcater?.data[att] ?? 0) + 1,
            unlock: {
                attributePoints: (charcater?.data?.unlock?.attributePoints ?? 0) - 1,
                habilityPoints: charcater?.data?.unlock?.habilityPoints ?? 0,
                maxPerkLevel: charcater?.data?.unlock?.maxPerkLevel ?? 0,
                perkPoints: charcater?.data?.unlock?.perkPoints ?? 0,
                levelPoint: charcater?.data?.unlock?.levelPoint ?? 0,
            }
        }

        await updateDoc(userDocRef, dataToUp).then(() => {
            toast.success("Atributos atualizados!");
        });

        setLoadingAtt(false);
    }

    const handleUpdateImage = async (fileImg: File) => {
        if (fileImg) {
            setloading(true);
            const charImgDocRef = doc(db, "character", charcater?.id ?? '');
            
            const resultImg = await uploadImage(fileImg, `character/${charcater?.id ?? ""}/image`);

            if(resultImg.error) {
                toast.error(resultImg.error);
                return;
            }

            const urlImage = resultImg.url ?? "";
            

            await updateDoc(charImgDocRef, {
                img: urlImage,
            }).then(() => {
                toast.success("Personagem atualizado!");
            });

            setloading(false);
        }
    }

    

    useEffect(() => {
        const armadures = itemsCharInventory?.filter((i) => i.data.type === 'armadure');

        if (charcater) {
            let baseDefense = charcater?.data.defense?.normal ?? 0;

            if(armadures && armadures.length > 0) {
                const armorBonus = armadures.reduce((acc, item) => acc + (item.data.name === 'Leve' ? 3 : 8), 0);
                baseDefense += armorBonus;
            }

            setCalcDefense(baseDefense);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [charcater, itemsCharInventory])

    return (
        <>
        <Container isToCloseSheet={isToCloseSheet}>
            <div className='close'>
                <button onClick={() => {
                    onClose();
                }}><i className="fa-solid fa-xmark"></i> fechar</button>
            </div>
            <div className='mainDetails'>
                <div className='charInfo'>
                    {(charcater?.data?.unlock?.levelPoint ?? 0) > 0 &&
                        <div className='infoBasics levelUp'>
                            <p className='levelUpP'>Você consegue upar!</p>
                            <button onClick={async () => {
                                if(charcater && classChar) {
                                    const leveled = await levelUp(charcater, classChar, charSubclass);

                                    setLevelUpInfo(leveled);

                                    if (leveled.state) toast.success("Nível aumentado!");
                                    else toast.error("Ocorreu alguma coisa errada...")
                                }
                            }}>Subir de nvível</button>
                        </div>
                    }
                    <div className='infoBasics'>
                        {loading ? <>
                            <div className='loadingImg'>
                                <ColorRing
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="color-ring-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="color-ring-wrapper"
                                    colors={['#d82c38', '#f4a860', '#fde350', '#53ac2a', '#3164c4']}
                                />
                            </div>
                        </> : <>
                            <div className='img'>
                                <input type='file' onChange={(e) => {
                                    if(e.target.files)
                                    handleUpdateImage(e.target.files[0]);
                                }} />
                                <Avatar src={charcater?.data.img ?? logo} sx={{ width: 100, height: 100 }} />
                                <span><i className="fa-regular fa-pen-to-square"></i></span>
                            </div>
                        </>}
                        <div className='infos'>
                            <div>
                                <p className='label'>Nome</p>
                                <p className='info'>{charcater?.data?.name}</p>
                            </div>
                            <div>
                                <p className='label'>Nível</p>
                                <p className='info'>{charcater?.data?.level}</p>
                            </div>
                            <div>
                                <p className='label'>Classe</p>
                                <p className='info'>{charcater?.data?.class?.title ?? ""}</p>
                            </div>
                            <div>
                                <p className='label'>Origem</p>
                                <p className='info'>{originChar?.data.title ?? "-"}</p>
                            </div>
                            <div>
                                <p className='label'>Defesa</p>
                                <p className='info'>{calcDefense ?? "-"}</p>
                            </div>
                        </div>
                        <div className='button'>
                            <button onClick={() => {
                                setEditInfo(true);
                            }}>Editar informações</button>
                        </div>
                    </div>

                    <div className='infoBasics infoMore'>
                        <div className='attributesTitle'>Atributos</div>
                        <div className='attributes'>
                            <div className='attrubuteItem'>
                                <p>AGI</p>
                                <span>{charcater?.data.AGI}</span>
                                {(charcater?.data.unlock.attributePoints ?? 0) > 0 && (charcater?.data.AGI ?? 0) < 5 ?
                                    <>
                                        {loadingAtt ? 
                                            <Vortex
                                            visible={true}
                                            height="30"
                                            width="30"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
                                            />
                                            : 
                                            <button onClick={() => {
                                                upAttribute('AGI');
                                            }}>
                                                <i className="fa-solid fa-angles-up"></i>
                                            </button>
                                            
                                        }
                                    </>
                                    :
                                    <button className='disable'><i className="fa-solid fa-angles-up"></i></button>
                                }
                            </div>
                            <div className='attrubuteItem'>
                                <p>INT</p>
                                <span>{charcater?.data?.INT}</span>
                                {(charcater?.data?.unlock?.attributePoints ?? 0) > 0 && (charcater?.data?.INT ?? 0) < 5 ?
                                    <>
                                        {loadingAtt ? 
                                            <Vortex
                                            visible={true}
                                            height="30"
                                            width="30"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
                                            />
                                            : 
                                            <button onClick={() => {
                                                upAttribute('INT');
                                            }}>
                                                <i className="fa-solid fa-angles-up"></i>
                                            </button>
                                            
                                        }
                                    </>
                                    :
                                    <button className='disable'><i className="fa-solid fa-angles-up"></i></button>
                                }
                            </div>
                            <div className='attrubuteItem'>
                                <p>VIG</p>
                                <span>{charcater?.data?.VIG}</span>
                                {(charcater?.data?.unlock?.attributePoints ?? 0) > 0 && (charcater?.data?.VIG ?? 0) < 5 ?
                                    <>
                                        {loadingAtt ? 
                                            <Vortex
                                            visible={true}
                                            height="30"
                                            width="30"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
                                            />
                                            : 
                                            <button onClick={() => {
                                                upAttribute('VIG');
                                            }}>
                                                <i className="fa-solid fa-angles-up"></i>
                                            </button>
                                            
                                        }
                                    </>
                                    :
                                    <button className='disable'><i className="fa-solid fa-angles-up"></i></button>
                                }
                            </div>
                            <div className='attrubuteItem'>
                                <p>PRE</p>
                                <span>{charcater?.data?.PRE}</span>
                                {(charcater?.data?.unlock?.attributePoints ?? 0) > 0 && (charcater?.data?.PRE ?? 0) < 5 ?
                                    <>
                                        {loadingAtt ? 
                                            <Vortex
                                            visible={true}
                                            height="30"
                                            width="30"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
                                            />
                                            : 
                                            <button onClick={() => {
                                                upAttribute('PRE');
                                            }}>
                                                <i className="fa-solid fa-angles-up"></i>
                                            </button>
                                            
                                        }
                                    </>
                                    :
                                    <button className='disable'><i className="fa-solid fa-angles-up"></i></button>
                                }
                            </div>
                            <div className='attrubuteItem'>
                                <p>FOR</p>
                                <span>{charcater?.data.FOR}</span>
                                {(charcater?.data.unlock.attributePoints ?? 0) > 0 && (charcater?.data.FOR ?? 0) < 5 ?
                                    <>
                                        {loadingAtt ? 
                                            <Vortex
                                            visible={true}
                                            height="30"
                                            width="30"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
                                            />
                                            : 
                                            <button onClick={() => {
                                                upAttribute('FOR');
                                            }}>
                                                <i className="fa-solid fa-angles-up"></i>
                                            </button>
                                            
                                        }
                                    </>
                                    :
                                    <button className='disable'><i className="fa-solid fa-angles-up"></i></button>
                                }
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className='habilitys'>
                    <div className='hability'>
                        <div className='title'>
                            <p>Habilidades</p>
                        </div>
                        <div className='itens'>
                            {(charcater?.data.unlock.habilityPoints ?? 0) > 0 && 
                                <>
                                    <div className='add' onClick={() => {setShowHabilityModal(true)}}>
                                        <i className="fa-regular fa-square-plus"></i>
                                        <p>Adicionar habilidade</p>
                                    </div>
                                    <Divider>Ou</Divider>
                                    <div className='addTranscend' onClick={() => {setShowHabilityTranscendedModal(true)}}>
                                        <DarkModeIcon />
                                        <p>Transcender</p>
                                    </div>
                                    <Divider style={{margin: "12px 0"}} />
                                </>
                            }
                            {habilitiesChar?.map((item, key) => (
                                <div className='item' key={key}>
                                    <p className='name'>{item.data.name}</p>
                                    <div className='detail' dangerouslySetInnerHTML={{ __html: item?.data?.description ?? "" }} />
                                </div>
                            ))}
                            {!habilitiesChar?.length && <small>Nenhuma habilidade ainda, jogue mais! :D</small>}
                        </div>
                    </div>
                    {originChar && originChar?.data && <>
                        <div className='hability'>
                            <div className='title'>
                                <p>Origem - {originChar.data.title}</p>
                            </div>
                            <div className='itens'>
                                <div className='item'>
                                    <p className='name'>Habilidade - {originChar.data.power?.name}</p>
                                    <div className='detail'>{originChar.data.power?.description}</div>
                                </div>
                            </div>
                        </div>
                    </>}

                    {habilityUnique && habilityUnique.length > 0 && (
                        <div className='hability'>
                            <div className='title'>
                                <p>Habilidades Únicas</p>
                            </div>
                            <div className='itens'>
                                {habilityUnique?.map((item, key) => (
                                    <div className='item' key={key}>
                                        <p className='name'>{item.data.title}</p>
                                        <div className='detail' dangerouslySetInnerHTML={{ __html: item?.data?.description ?? "" }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Seção de Habilidades Transcendidas */}
                    {habilityTranscendedChar && habilityTranscendedChar.length > 0 && (
                        <div className='habilityTranscended'>
                            <div className='title'>
                                <p>Habilidades Transcendidas</p>
                            </div>
                            <div className='itens'>
                                {habilityTranscendedChar?.map((item, key) => (
                                    <div className='item' key={key}>
                                        <p className='name'>
                                            <DarkModeIcon style={{fontSize: '16px', marginRight: '8px'}} />
                                            {item.data.name}
                                            {item?.data?.element?.name && (() => {
                                                const elementData = elements.find(el => el.id === item.data.element?.id);
                                                const elementColors = elementData?.data.colors;
                                                return (
                                                    <span 
                                                        style={{
                                                            marginLeft: '8px', 
                                                            fontSize: '0.9em',
                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            backgroundColor: elementColors?.background || '#43ff81',
                                                            color: elementColors?.color || '#333',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        {item.data.element.name}
                                                    </span>
                                                );
                                            })()}
                                        </p>
                                        <div className='detail' dangerouslySetInnerHTML={{ __html: item?.data?.description ?? "" }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    
                    {(charcater?.data.level ?? 0) >= 2 && <>
                        <div className='subclass'>
                            <div className='title'>
                                <p>Subclasse {charSubclass?.data.name && ' - '} <small>{charSubclass?.data.name}</small></p>
                            </div>
                            <div className='itens'>
                                {!charSubclass ? 
                                <>
                                <div className='add' onClick={() => {setShowSubclassModal(true)}}>
                                    <i className="fa-regular fa-square-plus"></i>
                                    <p>Adicionar subclasse</p>
                                </div>
                                </> : <>
                                {charSubclass.data.habilities?.map((item, key) => {
                                    // eslint-disable-next-line array-callback-return
                                    if(item.level <= (charcater?.data.level ?? 0)) {
                                        return (
                                            <div className='item' key={key}>
                                                <p className='name'>{item.name}</p>
                                                <div className='detail' dangerouslySetInnerHTML={{ __html: item.description ?? "" }} />
                                            </div>
                                        );
                                    }
                                    
                                    // eslint-disable-next-line array-callback-return
                                    return;
                                })}
                                </>}
                            </div>
                        </div>
                    </>}
                </div>
                <div className='skills'>
                    <div className='title'>
                        <p>Perícias <button onClick={() => {setShowPerksModal(true)}}>Editar</button></p>
                    </div>
                    <div className='itens'>
                        {skillsAll.map((item, key) => (
                            <div key={key} className='item'>
                                <div>
                                    <p>{item.name}</p>
                                    <div className='detailsSkills'>
                                        {item.expertise && <span className='expertise'>Nivel {item.expertise}</span> }
                                        <span className='base'>{item.base}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
        <Modal isOpen={showHabilityModal} handleCloseModal={handleCloseHabilityModal} >
            <ContainerModal>
                <div className='title'>
                    <p>Adicionar habilidade</p>
                </div>
                <div className='itens'>
                    {habilitiesToAdd?.map((item, key) => (
                        <div className={`item ${habilityToAdd === item && 'selected'}`} key={key} onClick={() => {
                            setHabilityToAdd(item);
                        }}>
                            <p className='name'>{item?.data?.name}</p>
                            <div className='detail' dangerouslySetInnerHTML={{ __html: item?.data?.description ?? "" }} />
                            {item?.data?.require && item?.data?.require?.length > 0 && 
                                <><strong>Pré-requisito:</strong> {item?.data?.require?.join(", ") ?? ""}</>
                            }
                        </div>
                    ))}
                </div>
                <div className='buttons'>
                    <button className={`${!habilityToAdd && 'disabled'}`} onClick={() => {

                        if(habilityToAdd && investigateRequirementAtribute(habilityToAdd) && investigateSkillRequirement(habilityToAdd)) {
                            toast.success("Habilidade adicionada com sucesso!");
                            addHability();
                        } else {
                            toast.error("Você não preenche os requisitos para essa habilidade.");
                        }
                        
                    }}>Adicionar</button>
                </div>
            </ContainerModal>
        </Modal>

        <Modal isOpen={showHabilityTranscendedModal} handleCloseModal={handleCloseHabilityTranscendedModal} >
            <ContainerModal>
                <div className='title'>
                    <p>Transcender habilidade</p>
                </div>
                <div className='itens'>
                    {habilityTranscendedToAddList?.map((item, key) => (
                        <div className={`item ${habilityTranscendedToAdd === item && 'selected'}`} key={key} onClick={() => {
                            setHabilityTranscendedToAdd(item);
                        }}>
                            <p className='name'>
                                <DarkModeIcon style={{fontSize: '16px', marginRight: '8px'}} />
                                {item?.data?.name}
                                {item?.data?.element?.name && (() => {
                                    const elementData = elements.find(el => el.id === item.data.element?.id);
                                    const elementColors = elementData?.data.colors;
                                    return (
                                        <span 
                                            style={{
                                                marginLeft: '8px', 
                                                fontSize: '0.9em',
                                                padding: '2px 6px',
                                                borderRadius: '4px',
                                                backgroundColor: elementColors?.background || '#cacaca',
                                                color: elementColors?.color || '#333',
                                                fontWeight: '500',
                                                boxShadow: `0 0 6px ${elementColors?.background || '#cacaca'}`
                                            }}
                                        >
                                            {item.data.element.name}
                                        </span>
                                    );
                                })()}
                            </p>
                            <div className='detail' dangerouslySetInnerHTML={{ __html: item?.data?.description ?? "" }} />
                            {item?.data?.require && item?.data?.require?.length > 0 && 
                                <><strong>Pré-requisito:</strong> {item?.data?.require?.join(", ") ?? ""}</>
                            }
                        </div>
                    ))}
                </div>
                <div className='buttons'>
                    <button className={`${!habilityTranscendedToAdd && 'disabled'}`} onClick={() => {
                        addHabilityTranscended();
                    }}>Transcender</button>
                </div>
            </ContainerModal>
        </Modal>

        <Modal isOpen={showSubclassModal} handleCloseModal={handleCloseHabilityModal} >
            <ContainerModal>
                <div className='title'>
                    <p>Selecionar subclasse</p>
                </div>
                <div className='subclass'>
                    <div className='subclassItens'>
                        {subclasses?.filter(i => i?.data?.classId === charcater?.data?.class?.id).map((item, key) => (
                            <div key={key} className={`item ${subclassToAdd === item && 'selected'}`} onClick={() => {
                                setSubclassToAdd(item);
                            }}>
                                <p className='name'>{item.data.name}</p>
                            </div>
                        ))}
                        
                    </div>
                    {subclassToAdd && 
                        <div className='subclassItensDetails'>
                            <div className='subclassTitle'>{subclassToAdd?.data.name}</div>
                            <div className='subclassDescription' dangerouslySetInnerHTML={{ __html: subclassToAdd?.data.description ?? "" }} />
                            <div className='subclassskills'>
                                {subclassToAdd?.data.habilities.map((i, keyI) => (
                                    <div className='subclassskillsItens' key={keyI}>
                                        <p>Nível {i.level} - {i.name}</p>
                                        <div className='detailSub' dangerouslySetInnerHTML={{ __html: i.description ?? "" }} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                </div>
                <div className='buttons'>
                    <button className={`${!subclassToAdd && 'disabled'}`} onClick={() => {
                        addSubclass();
                    }}>Selecionar</button>
                </div>
            </ContainerModal>
        </Modal>


        <Modal isOpen={showPerksModal} handleCloseModal={handleCloseHabilityModal} >
            <ContainerModal>
                <div className='title'>
                    <p>Selecione suas perícias</p>
                    {(charcater?.data.unlock?.perkPoints ?? 0) > 0 && <>
                        <span>Você tem {(charcater?.data.unlock?.perkPoints ?? 0) - perksToUpgrade.length} pontos restantes de perícia.</span>
                    </>}
                </div>
                <div className='perks'>
                    <div className='perksItens'>
                        {skillsAll.map((item, key) => (
                            <div key={key} className={`item`} onClick={() => {
                                // setSubclassToAdd(item);
                            }}>
                                <div className='name'>
                                    {item.name}
                                    {perksToUpgrade?.some(i => i.id === item.id) ? <>
                                        {(item.expertise ?? 0) > 0 ? 
                                            <span>Nível {item.expertise} <i className="fa-solid fa-arrow-right"></i> Nível {(item.expertise ?? 0) + 1}</span>
                                            :
                                            <span>Nível 0 <i className="fa-solid fa-arrow-right"></i> Nível 1</span>
                                        }
                                    </> : <>
                                        {item.expertise && <span>Nível {item.expertise}</span>}
                                    </>}
                                </div>
                                {verifyPerkToImprove(item) || perksToUpgrade?.some(i => i.id === item.id) ? 
                                    <div className='button'>
                                        {perksToUpgrade?.some(i => i.id === item.id) ? <>
                                        <button
                                            className='cancel'
                                            onClick={() => {
                                                const newperksToAdd = perksToUpgrade.filter((i) => i.id !== item.id);
                                                setPerksToUpgrade(newperksToAdd);
                                            }}
                                        >
                                            Remover <i className="fa-solid fa-xmark"></i>
                                        </button>
                                        </> : <>
                                        <button
                                            onClick={() => {
                                                const newPerkItem = {
                                                    base: item.base,
                                                    expertise: (item.expertise ?? 0) + 1,
                                                    id: item.id,
                                                    name: item.name,
                                                } as skillTy;
                                                setPerksToUpgrade([...perksToUpgrade, newPerkItem]);
                                            }}
                                        >
                                            Melhorar <i className="fa-solid fa-arrow-up"></i>
                                        </button>
                                        </>}
                                    </div>
                                    :
                                    <div className='button'>
                                        <p>Limite máximo</p>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </div>
                <div className='buttons buttonsperk'>
                    <button className='cancel'>Cancelar</button>
                    <button onClick={() => {
                        if(charcater?.data?.unlock?.perkPoints)
                            if(charcater?.data?.unlock?.perkPoints > perksToUpgrade.length) {
                                toast.error("Você precisa atribuitr todos os pontos de perícia.");
                            } else {
                                updatePerks();
                            }
                    }}>Salvar</button>
                </div>
            </ContainerModal>
        </Modal>
        <Modal isOpen={!!levelUpInfo} handleCloseModal={handleCloseModalLevelUp}>
            <ContainerLevel>
                <p>Você subiu de nível!</p>
                <div className='data'><div>Nivel</div> <div>{(charcater?.data.level ?? 0) - 1} <i className="fa-solid fa-arrow-right"></i> {charcater?.data.level ?? 0}</div></div>
                {campain?.basics.life && <div className='data'><div>PV max</div> <div>{levelUpInfo?.beforeBasic.life.max ?? 0} <i className="fa-solid fa-arrow-right"></i> {levelUpInfo?.basics.life.max ?? 0}</div></div>}
                {campain?.basics.pe && <div className='data'><div>PE max</div> <div>{levelUpInfo?.beforeBasic.pe.max ?? 0} <i className="fa-solid fa-arrow-right"></i> {levelUpInfo?.basics.pe.max ?? 0}</div></div>}
                {campain?.basics.sanity && <div className='data'><div>Sanidade max</div> <div>{levelUpInfo?.beforeBasic.sanity.max ?? 0} <i className="fa-solid fa-arrow-right"></i> {levelUpInfo?.basics.sanity.max ?? 0}</div></div>}
                
                {levelUpInfo?.messages.map((item, key) => (
                    <div className='dataMessage' key={key}>
                        <p>{item.title}</p>
                        <span>{item.description}</span>
                    </div>
                ))}
                
            </ContainerLevel>    
        </Modal>
        {charcater && 
            <Modal isOpen={editInfo} handleCloseModal={handleClodeEdit} >
                <EditInfo charcater={charcater} toast={toast} />
            </Modal>
        }
        </>
    )
}

export default SheetDetails;